module.exports = __webpack_public_path__ + "media/16.e0601956.mp3";